import React, { Component } from 'react';
import App_data from '../../../config/App_data';
import FD from '../../../RestAPI/fetchData';
import language from '../../../../assets/languages/language';
import SoaP_SubscriptionCheck from '../../../RestAPI/SoaPSubscription';
import PartnerSoaP_SubscriptionCheck from '../../../RestAPI/PartnerSubscription/SoaPSubscription';
import AlertMessage from '../../../config/alertMessage';
import { fetchFreeUseSubscriptionMessage } from '../../../../services/exams';
import UserAnsweredNotAnsweredStatus from '../../../../components/UserAnsweredNotAnsweredStatus';
import { renderHTMLContent } from '../../../../common/function';
/* eslint-disable*/
class SOA_P_Viewques extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alert_status: false,
      MessageTitle: `${language.LC().ALERT}`,
      MessageContent: `${language.LC().ERROR}`,
      subscriptionMessage: AlertMessage.messageContent_soa_p,
      contentHeader: language.LC().SUBSCRIBE_FOR_1500_PRACTICE_QUESTIONS,
      questions: [],
      token: '',
      idname: '',
      readingName: this.props.params.reading,
      subscriptionstatus: this.props.params.subscriptionstatus,
      ValidToken: false,
      chapter_id: '',
      offset: 0,
      limit: 1000,
      answered: [],
      answered_state: [],
      showFreePremium: true,
      chapters: [],
      subscription_details: '',
      subscription_details_for_isActive: '',
      chapter_video_redirect: '',
      selectedmenu: 'soa_p',
    };
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  async componentDidMount() {
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    if (storage_session) {
      this.setState({
        idname: storage_session['idname'],
        token: storage_session['token'],
      });
    }
    window.scrollTo(0, 0);
    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
    };
    this.setContentMessage();
    await FD.callAPI(App_data.backend_api + '/user/getProfileInfo', data).then(async resp => {
      if (resp.profileInfo.role === 'partner') {
        if (resp.profileInfo.exam_selected === '' && resp.profileInfo.exam_package === '') {
          this.setState({
            showFreePremium: true,
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;

          var dataset = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await PartnerSoaP_SubscriptionCheck.checkSoaPSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      } else {
        if (resp.profileInfo.exam_selected === '') {
          this.setState({
            showFreePremium: true,
          });
        } else {
          var subscription_details = resp.profileInfo.subscription_details
            ? JSON.parse(resp.profileInfo.subscription_details)
            : resp.profileInfo.subscription_details;

          this.setState({
            subscription_details: subscription_details,
          });
          var data_arr = resp.profileInfo.exam_selected
            ? JSON.parse(resp.profileInfo.exam_selected)
            : null;
          var dataset = {
            idname: storage_session['idname'],
            token: storage_session['token'],
            examid: data_arr,
          };
          await FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
            async resp_exam => {
              if (resp_exam.success) {
                var exam_data = resp_exam.examData;
                var selectedmen = this.state.selectedmenu;
                var isInArray_var = false;
                isInArray_var = await SoaP_SubscriptionCheck.checkSoaPSubscription(
                  selectedmen,
                  exam_data,
                );
                if (isInArray_var) {
                  this.setState({ showFreePremium: false });
                } else {
                  this.setState({ showFreePremium: true });
                }
              } else {
                console.log('fail');
              }
            },
          );
        }
      }
    });

    var data = {
      idname: storage_session['idname'],
      token: storage_session['token'],
      reading_id: this.props.params.id,
      chapter_id: this.props.params.chapter_no,
      offset: this.state.offset,
      limit: this.state.limit,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    await FD.callAPI(App_data.backend_api + '/soa_p_question_bank/getQuestions', data).then(
      resp => {
        // console.log(resp)
        if (resp.success) {
          this.setState({ ValidToken: true });
          this.setState({ questions: resp.questions });
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  }

  setContentMessage = async () => {
    const result = await fetchFreeUseSubscriptionMessage({
      exam: 'soa_p',
      section: 'question',
    });
    if (result.success) {
      const { html_content, header } = result.data;
      this.setState({
        subscriptionMessage: html_content,
        contentHeader: header,
      });
    }
  };
  _getReadings = () => {
    this.context.router.push({
      pathname: `/soa/probability/readings/${this.props.params.chapter_no}`,
      // state: {
      //   token: this.state.token,
      //   idname: this.state.idname,
      //   chapter: this.props.location.state.reading.chapter_no,
      // },
    });
  };

  _beginChapter = (item, e) => {
    // console.log(item)
    this.context.router.push({
      pathname:
        '/soa/probability/beginchapter/' + item.chapter_id + '/' + item.reading_id + '/' + item.id,
      state: {
        token: this.state.token,
        idname: this.state.idname,
        reading: item.reading_id,
        chapter: item.chapter_id,
      },
    });
  };

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  render() {
    let questions = this.state.questions;
    let data = '';
    if (this.state.questions.length) {
      data = questions.map((item, index) => (
        <div key={index} className='col-md-6 col-lg-4'>
          <div onClick={this._beginChapter.bind(this, item)} className='border_box'>
            <div className='border_box_title d-flex'>
              <img
                src={App_data.frontend_url + '/img/question_bank/question_icon-blu.svg'}
                className='margin_bottom_20'
                width='30'
                alt=''
              />
              <p className='ml-1'>
                {/* {item.name} */}
                {item.name} ({language.LC().Q} {item.id})
                {/* {language.LC().Q} {item.id} {item.name} */}
              </p>
            </div>
            <div className='padding_box'>
              <div contentEditable='false' className='view_question_height view_questionhtml'>
                {renderHTMLContent(
                  item.question.substring(
                    0,
                    item.question.indexOf('$$') !== -1 ? item.question.indexOf('$$') : 450
                  ) + '...'
                )}
              </div>
              <p>{this.state.answered_state[index]}</p>
              <UserAnsweredNotAnsweredStatus
                itemid={item.id}
                chapter_id={this.props.params.chapter_no}
                reading_id={this.props.params.id}
                idname={this.state.idname}
                token={this.state.token}
                answered_state={index}
                examRoute='soa_p_question_bank'
              />
            </div>
          </div>
        </div>
      ));
    } else {
      data = (
        <div className='loader_box'>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      );
    }

    return (
      <div className='animated fadeIn'>
        <div className='row'>
          <div className='col-md-8 margin_bottom_20'>
            <h1 className='section_head'>{this.state.readingName}</h1>
          </div>

          <div className='col-md-4 text-md-right margin_bottom_20'>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {' '}
              {language.LC().CHANGE_READING}{' '}
            </button>
          </div>
        </div>
        <div className='row'>
          {data}
          {this.state.subscriptionstatus === 'free' ? (
            <div className='col-md-6 col-lg-4'>
              <div className='border_box' onClick={this._getSubscribe}>
                <div className='border_box_title'>
                  <img
                    src={App_data.frontend_url + '/img/question_bank/question_icon-blu.svg'}
                    className='margin_bottom_20'
                    width='30'
                    alt=''
                  />
                  <p> {this.state.contentHeader} </p>
                </div>
                <div className='padding_box_free'>
                  {renderHTMLContent(this.state.subscriptionMessage, "div", "view_question_height view_questionhtml modal-info-view-for-plan", { contentEditable: "false" })}
                </div>
                <div className='subscibe__btn text-center'>
                  <button
                    type='button'
                    className='btn btn-primary pointer_class'
                    onClick={this._getSubscribe}
                  >
                    {language.LC().SUBSCRIBE}
                  </button>
                </div>
              </div>
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }
}

export default SOA_P_Viewques;



// WEBPACK FOOTER //
// ./src/views/SOA/Probability/Viewques/Viewques.js